const allProperties = (allProperties = [], action) => {
  switch (action.type) {
    case 'FETCH_ALL_PROPERTIES':
      return action.payload
    default:
      return allProperties
  }
}
export default allProperties
